(ns frontend.exports.exceljs.sheet
  (:require [clojure.string :as string]
            [oops.core :as oops]))

(defn set-columns [sheet column-labels]
  (let [column-infos (->> column-labels
                          (map (fn [lbl]
                                 {:header lbl
                                  :key    (string/replace lbl #"([^a-zA-Z0-9])*" "")
                                  :width  30}))
                          (vec))]
    (aset sheet "columns" (clj->js column-infos))))

(defn set-column-infos
  [sheet column-infos]
  (aset sheet "columns" (clj->js column-infos)))

(defn add-rows [sheet rows]
  (->> rows
       (map (fn [row]
              (.call (aget sheet "addRow") sheet (clj->js row))))
       (doall)))


(defn set-column-cell-formats [sheet col-index num-format skip-header?]
  (let [col (.call (aget sheet "getColumn") sheet col-index)]
    (.call (aget col "eachCell") col (fn [& args]
                                       (aset (first args) "numFmt" num-format)))))

(defn set-row-coll-formats [sheet row-idx start-col end-col]
  (let [row (oops/ocall! sheet "getRow" row-idx)]
    (oops/ocall! row "each")))


(defn option-sanitize
  [opt]
  (-> opt
      (string/replace #"\s" "")
      (string/replace #"\-" "")
      (string/replace #"\(" "")
      (string/replace #"\)" "")
      (string/replace #"/" "")
      (string/replace #"\&" "")))

(defn set-cell-formats
  [sheet start-row end-row start-col end-col num-format options]
  (doseq [row-idx (range start-row end-row)]
    (let [sh-row (oops/ocall! sheet "getRow" row-idx)]
      (doseq [col-idx (range start-col end-col)]
        (let [sh-cell (oops/ocall! sh-row "getCell" col-idx)]
          (if (seq options)
            (let [excel-options (if (boolean? (first options))
                                  (pr-str (string/join "," options))
                                  (pr-str (string/join "," (map option-sanitize options)))
                                  #_(pr-str (string/join "," (map pr-str options))))]
              (oops/oset! sh-cell "dataValidation"
                          (clj->js {"type"       "list"
                                    "allowBlank" "true"
                                    "formulae"   [excel-options]
                                    })))
            (oops/oset! sh-cell "numFmt" num-format)))))))

(defn set-header-fill [elem]
  (aset elem "fill" (clj->js {:type     "gradient"
                              :gradient "angle"
                              :degree   90
                              :stops    [{:position 0
                                          :color    {:argb "8ABF4C"}}
                                         {:position 1
                                          :color    {:argb "7AAF3C"}}]})))


(defn set-header-row-styles [sheet idx]
  (let [row (.call (aget sheet "getRow") sheet idx)]
    (set-header-fill row)))
